// extracted by mini-css-extract-plugin
module.exports = {"container":"NotificationsContainer_container__w5AIZ","title":"NotificationsContainer_title__QwV-8"};